/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Skip_To_Confirm_ButtonInputs */

const en_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to Confirm`)
};

const fr_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à la confirmation`)
};

const de_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter zum Bestätigen`)
};

const it_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla conferma`)
};

const ru_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к подтверждению`)
};

const es_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar para confirmar`)
};

const zh_cn2_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过确认`)
};

const ja_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認へスキップ`)
};

const hi_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुष्टि करने के लिए आगे बढ़ें`)
};

const pt_pt2_new_project_skip_to_confirm_button = /** @type {(inputs: New_Project_Skip_To_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para Confirmar`)
};

/**
* | output |
* | --- |
* | "Skip to Confirm" |
*
* @param {New_Project_Skip_To_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_skip_to_confirm_button = /** @type {((inputs?: New_Project_Skip_To_Confirm_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Skip_To_Confirm_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_skip_to_confirm_button(inputs)
	if (locale === "de") return de_new_project_skip_to_confirm_button(inputs)
	if (locale === "it") return it_new_project_skip_to_confirm_button(inputs)
	if (locale === "ru") return ru_new_project_skip_to_confirm_button(inputs)
	if (locale === "es") return es_new_project_skip_to_confirm_button(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_skip_to_confirm_button(inputs)
	if (locale === "ja") return ja_new_project_skip_to_confirm_button(inputs)
	if (locale === "hi") return hi_new_project_skip_to_confirm_button(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_skip_to_confirm_button(inputs)
	return en_new_project_skip_to_confirm_button(inputs)
});